module.exports = __webpack_public_path__ + "static/media/clarinet.d9497764.svg";